import React from 'react';

const WhereWeSwim = () => {
  return (
    <div>
      <h1>Where we swim</h1>
      <p>
        It all begins from the beach, however in winter, some choose to jump in from the first pier landing to avoid the cold of the shallow waters.  We never swim alone, so before heading out, groups agree on the course they will take - influenced by the weather and tidal conditions.
      </p>
      <p>
        One of the joys of open water swimming is that conditions are never the same - each swim is unique and never regretted.
      </p>
      <img src="/images/heatmap.jpg" alt="Heater map of Iceberger swim courses" />
      <p>Heat map of Iceberger swim courses</p>
      <p>
        Below is an overview of the most popular swim courses. The link will open a file with distance measurement of the main courses.
      </p>
      <a href="/Brighton+Iceberger+Swim+Distances.pdf" target="_blank" rel="noopener noreferrer">
        View Swim Distances
      </a>
      <p>© Brighton Icebergers @ RBYC</p>
    </div>
  );
};

export default WhereWeSwim;
